import React, { useLayoutEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { langState, cookieConsentState } from "../recoilAtom";
// import "./cookies.scss";

const CookieBanner = () => {
  const cookieText: any = {
    "pl-PL": {
      h2: "Dbamy o Twoją prywatność",
      p: "Medinice S.A. używa plików cookie w celu ulepszenia i dostosowania doświadczeń użytkowników na naszej stronie internetowej. Wybierając „Akceptuj”, wyrażasz zgodę na używanie wszystkich plików cookie, które zbierają i wykorzystują informacje o Twoich interakcjach z naszą stroną, aby dostosować treści do Twoich potrzeb i ułatwić korzystanie z serwisu. Prosimy o zapoznanie się z naszą Polityką Prywatności, aby uzyskać więcej informacji.",
      button1: "Zgoda",
      button2: "Odmowa",
    },
    "en-US": {
      h2: "We Care About Your Privacy",
      p: "Medinice S.A. uses cookies to improve and customize users experience on our website. By selecting 'Accept', you consent to the use of all cookies that gather and use information about your interactions with our site to provide personalized content and enhance your digital experience. Please read our Privacy Policy for more information.",
      button1: "Accept",
      button2: "Decline",
    },
  };

  const [cookieAccepted, setCookieAccepted] =
    useRecoilState(cookieConsentState);
  const [lang, setLang] = useRecoilState(langState);

  useLayoutEffect(() => {
    document.cookie.indexOf("CookieBy=MediniceCookie") !== -1
      ? setCookieAccepted(true)
      : setCookieAccepted(false);
  }, []);

  const acceptCookie = () => {
    document.cookie =
      "CookieBy=MediniceCookie; accepted=true; SameSite=None; Secure; max-age=" +
      60 * 60 * 24 * 60;
    setCookieAccepted(true);
  };

  const declineCookie = () => {
    document.cookie =
      "CookieBy=MediniceCookie; accepted=false; SameSite=None; Secure; max-age=" +
      60 * 60 * 24 * 60;
    setCookieAccepted(true);
  };

  return (
    <>
      {!cookieAccepted && (
        <div className="flex flex-col fixed bottom-6 left-6 bg-white lg:p-6 rounded-lg shadow-lg gap-1 lg:max-w-[560px] z-40 p-4 max-w-[calc(100vw-48px)] fade-in-from-top">
          <h2 className="text-lg lg:text-xl font-bold">
            {cookieText[lang].h2}
          </h2>
          <p className="text-sm lg:text-base">{cookieText[lang].p}</p>
          <div className="flex gap-4 pt-2">
            <button
              className="font-bold text-base px-4 py-2 rounded-full text-white w-max transition-all duration-700 ease-in bg-blue-600 border-2 border-solid border-blue-600"
              onClick={() => acceptCookie()}
            >
              {cookieText[lang].button1}
            </button>
            <button
              className="font-bold text-base px-4 py-2 rounded-full text-blue-600 w-max  transition-all duration-700 ease-in bg-white border-2 border-solid border-blue-600"
              onClick={() => declineCookie()}
            >
              {cookieText[lang].button2}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
